import { createContext } from "react";

export const ContentViewportContext = createContext<HTMLElement | null>(null);
